import { useState } from 'react';
import bem from '../../../../utils/bem';
import Input from '../Input';
import Icon from '../../Icon/Icon';

const OptionsToggle = ({
  groupId,
  groupLegend,
  options,
  selected,
  onOptionSelect,
  mods,
  extra,
}) => {
  const [selectedOption, setSelectedOption] = useState(selected);
  const baseCSSClass = 'a-toggle';
  const onOptionSelectHandler = (val) => {
    onOptionSelect(val);
    setSelectedOption(val);
  };
  const optionsList = options.map((option) => {
    const OptionContent = () => (
      <span className={bem('option-content', [], baseCSSClass)}>
        <span className={bem('option-icon', [], baseCSSClass)}>
          {option.icon && (
            <Icon
              className={bem('icon-svg', [], baseCSSClass)}
              iconName={option.icon}
              width={24}
              height={24}
            />
          )}
        </span>
        <span className={bem('option-shortname', [], baseCSSClass)}>
          {option.shortName}
        </span>
        <span className={bem('option-name', [], baseCSSClass)}>
          {option.name}
        </span>
      </span>
    );
    return (
      <Input
        type="radio"
        key={option.value}
        name={groupId}
        onChange={() => onOptionSelectHandler(option.value)}
        children={<OptionContent />}
        extraInput={['visually-hidden']}
        extraLabel={[
          bem('label', [], baseCSSClass),
          selectedOption === option.value ? 'is--active' : '',
        ]}
      />
    );
  });
  return (
    <fieldset className={bem(baseCSSClass, mods, '', extra)}>
      <legend className="visually-hidden">{groupLegend}</legend>
      {optionsList}
    </fieldset>
  );
};

export default OptionsToggle;
